import SvgIcon from '@/components/SvgIcon/index.vue';

const requireAll = (requireContext) => requireContext.keys().map(requireContext);
const req = require.context('./svg', false, /\.svg$/);
requireAll(req);

export default (app) => {
  app.component('svg-icon', SvgIcon);
};
